import { z } from 'zod';
import { BicSchema, CurrencyCodeSchema, IbanSchema, IsoTimestampSchema, UuidSchema, } from './primitives.js';
import { AccountStatusSchema } from './enums.js';
/**
 * Bank account opened with Swan. Mirrors the `swan_accounts` table.
 * Source of truth = Swan API; our row is a cache + audit reference.
 */
export const AccountSchema = z.object({
    id: UuidSchema,
    account_holder_id: UuidSchema,
    swan_account_id: z.string().min(1),
    iban: IbanSchema,
    bic: BicSchema,
    currency: CurrencyCodeSchema.default('EUR'),
    status: AccountStatusSchema,
    /** Set when status transitions to `review` (USP #1 Account Health). */
    review_started_at: IsoTimestampSchema.nullable(),
    review_reason: z.string().nullable(),
    created_at: IsoTimestampSchema,
});
//# sourceMappingURL=account.js.map